export const AUTH_STORAGE_KEY = "app.auth.user";

export type VerificationTokenResponse = {
	success: boolean;
	response?: string;
	error?: string;
	details?: Record<string, unknown>;
};
